<template>
    <div>
        <notifications></notifications>

        <navbar :show-navbar="showMenu">
          
          <div class="navbar-wrapper">
            <div class="navbar-toggle" :class="{toggled: showMenu}">
              <navbar-toggle-button @click.native="toggleNavbar">
              </navbar-toggle-button>
            </div>
            <a class="navbar-brand mx-auto" href="/">
              <img src="https://kjc.sgp1.digitaloceanspaces.com/misc/kjc-logoo.png" alt="kristu-jayanti-logo">
            </a>
          </div>

          <template slot="navbar-menu">
            <router-link class="nav-item" tag="li" to="/home">
              <a class="nav-link">
                <i class="now-ui-icons business_globe"></i>
                Home
              </a>
            </router-link>
            <!-- <router-link class="nav-item" tag="li" to="/events">
              <a class="nav-link">
                <i class="now-ui-icons business_badge"></i>
                Events
              </a>
            </router-link>
            <li class="nav-item">
              <a class="nav-link" target="_blank" href="http://glimpses.t38.in">
                <i class="now-ui-icons education_paper"></i>
                Glimpses
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" target="_blank" href="https://play.google.com/store/apps/details?id=com.kristujayanti.app">
                <i class="now-ui-icons tech_mobile"></i>
                KJC+ App
              </a>
            </li> -->
            <router-link class="nav-item" tag="li" to="/auth/login" v-if="$currentUser == null">
              <a class="nav-link">
                <i class="now-ui-icons users_circle-08"></i>
                Login
              </a>
            </router-link>
            <router-link class="nav-item" tag="li" to="/dashboard" v-if="$currentUser != null">
              <a class="nav-link">
                <i class="now-ui-icons objects_planet"></i>
                Dashboard
              </a>
            </router-link>
          </template>
            
        </navbar>

        <div class="wrapper wrapper-full-page">
            <div class="full-page section-image" :class="pageClass" filter-color="black">
                <div class="content">
                    <div class="container">
                    <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
                        <router-view></router-view>
                    </zoom-center-transition>
                    </div>
                </div>
                <footer class="footer">
                    <div class="container-fluid">
                        <div class="copyright center">
                            Copyright &copy; {{year}} Kristu Jayanti (Deemed to be University) <br>Developed by <a href="http://www.three38inc.com/"><img src="https://kjc.sgp1.digitaloceanspaces.com/misc/logo-full-white.png" alt="three38-logo-signature-light" /></a>
                        </div>
                    </div>
                </footer>
                <div class="full-page-background grid" style="backgroundImage: url('/img/bg/bg-1.jpg')"></div>
            </div>
        </div>

    </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from 'src/components';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  mounted(){
    // console.log(this.$currentUser);
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page'
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.footer{
  .copyright{
    float: none;
    width: 100%;

    &.center{
      text-align: center;
    }

    &.right{
      text-align: right;
    }

    &.left{
      text-align: left;
    }

    img{
      max-height: 20px;
      width: auto;
    }
  }
}

.navbar-brand img{
  max-height: 60px;
}

.nav-open{
  .navbar-brand img{
    filter: invert(1) grayscale(1);
  }
}

</style>
